import { useEffect, useId, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { useBasket } from "../basket/BasketContext";
import { companyLines, hasCompanyDetails, hasText, site } from "../config/site";
import { collections } from "../data/collections";
import { catalogueIsLive } from "../data/products";

const information = [
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
  { to: "/delivery-and-returns", label: "Delivery and returns" },
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" }
];

export function Layout() {
  const { totalQuantity } = useBasket();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const navId = useId();
  const company = companyLines();
  const showBasket = catalogueIsLive();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <div className="app-shell">
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <header className="site-header">
        <div className="header-inner">
          <Link className="wordmark" to="/">
            <span className="wordmark-mark">BJ</span>
            <span className="wordmark-name">{site.brandName}</span>
          </Link>
          <button
            className="nav-toggle"
            type="button"
            aria-expanded={open}
            aria-controls={navId}
            onClick={() => setOpen((current) => !current)}
          >
            Menu
          </button>
          <nav id={navId} className={open ? "site-nav open" : "site-nav"} aria-label="Primary">
            <NavLink to="/collections" end>
              Collections
            </NavLink>
            {collections.map((collection) => (
              <NavLink key={collection.slug} to={`/collections/${collection.slug}`}>
                {collection.name}
              </NavLink>
            ))}
            <NavLink to="/about">About</NavLink>
            <NavLink to="/contact">Contact</NavLink>
            {showBasket ? (
              <NavLink className="basket-link" to="/basket">
                Basket{totalQuantity > 0 ? ` (${totalQuantity})` : ""}
              </NavLink>
            ) : null}
          </nav>
        </div>
      </header>
      <Outlet />
      <footer className="site-footer">
        <div className="footer-inner">
          <div>
            <p className="kicker">{site.brandName}</p>
            <p>Jewellery for everyday moments.</p>
            {hasCompanyDetails()
              ? company.map((line) => (
                  <p key={line} className="muted">
                    {line}
                  </p>
                ))
              : null}
          </div>
          <div className="footer-links">
            {information.map((item) => (
              <Link key={item.to} to={item.to}>
                {item.label}
              </Link>
            ))}
          </div>
          <div>
            {hasText(site.contact.email) ? (
              <p>
                <a href={`mailto:${site.contact.email}`}>{site.contact.email}</a>
              </p>
            ) : null}
            {hasText(site.contact.phone) ? <p>{site.contact.phone}</p> : null}
            {hasText(site.contact.hours) ? <p className="muted">{site.contact.hours}</p> : null}
          </div>
        </div>
      </footer>
    </div>
  );
}
